// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "rescript/lib/es6/belt_Result.js";
import * as GraphqlTag from "graphql-tag";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";
import * as HasuraTypes$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/HasuraTypes.res.mjs";
import * as UserContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/UserContext.res.mjs";

var Raw = {};

var query = GraphqlTag.gql(["fragment StoryverseUserPointsFragment on storyverse_user_points_view   {\n__typename  \npoints  \ncurrentLevel  {\n__typename  \npoints  \nlevel  \n}\n\nnextLevel  {\n__typename  \npoints  \nlevel  \n}\n\n}\n"]);

function parse(value) {
  var value$1 = value.points;
  var value$2 = value.currentLevel;
  var value$3 = value.nextLevel;
  return {
          __typename: value.__typename,
          points: !(value$1 == null) ? value$1 : undefined,
          currentLevel: !(value$2 == null) ? value$2.map(function (value) {
                  return {
                          __typename: value.__typename,
                          points: value.points,
                          level: value.level
                        };
                }) : undefined,
          nextLevel: !(value$3 == null) ? value$3.map(function (value) {
                  return {
                          __typename: value.__typename,
                          points: value.points,
                          level: value.level
                        };
                }) : undefined
        };
}

function serialize(value) {
  var value$1 = value.nextLevel;
  var nextLevel = value$1 !== undefined ? value$1.map(function (value) {
          var value$1 = value.level;
          var value$2 = value.points;
          var value$3 = value.__typename;
          return {
                  __typename: value$3,
                  points: value$2,
                  level: value$1
                };
        }) : null;
  var value$2 = value.currentLevel;
  var currentLevel = value$2 !== undefined ? value$2.map(function (value) {
          var value$1 = value.level;
          var value$2 = value.points;
          var value$3 = value.__typename;
          return {
                  __typename: value$3,
                  points: value$2,
                  level: value$1
                };
        }) : null;
  var value$3 = value.points;
  var points = value$3 !== undefined ? value$3 : null;
  var value$4 = value.__typename;
  return {
          __typename: value$4,
          points: points,
          currentLevel: currentLevel,
          nextLevel: nextLevel
        };
}

function verifyArgsAndParse(_StoryverseUserPointsFragment, value) {
  return parse(value);
}

function verifyName(param) {
  
}

var StoryverseUserPointsFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

var Raw$1 = {};

var query$1 = GraphqlTag.gql([
      "query StoryverseSpQuery($userId: String!, $userUuid: uuid!)  {\ncurrentStudent(userId: $userId)  {\n__typename  \ngems  \n}\n\nbog_user_backgrounds  {\n__typename  \nimage  {\n__typename  \ntitle  \n}\n\n}\n\nstoryverse_user_points_view(where: {userId: {_eq: $userUuid}})  {\n...StoryverseUserPointsFragment   \n}\n\n}\n",
      ""
    ], query);

function parse$1(value) {
  var value$1 = value.currentStudent;
  var value$2 = value.bog_user_backgrounds;
  var value$3 = value.storyverse_user_points_view;
  return {
          currentStudent: !(value$1 == null) ? ({
                __typename: value$1.__typename,
                gems: value$1.gems
              }) : undefined,
          bog_user_backgrounds: value$2.map(function (value) {
                var value$1 = value.image;
                return {
                        __typename: value.__typename,
                        image: {
                          __typename: value$1.__typename,
                          title: value$1.title
                        }
                      };
              }),
          storyverse_user_points_view: value$3.map(parse)
        };
}

function serialize$1(value) {
  var value$1 = value.storyverse_user_points_view;
  var storyverse_user_points_view = value$1.map(serialize);
  var value$2 = value.bog_user_backgrounds;
  var bog_user_backgrounds = value$2.map(function (value) {
        var value$1 = value.image;
        var value$2 = value$1.title;
        var value$3 = value$1.__typename;
        var image = {
          __typename: value$3,
          title: value$2
        };
        var value$4 = value.__typename;
        return {
                __typename: value$4,
                image: image
              };
      });
  var value$3 = value.currentStudent;
  var currentStudent;
  if (value$3 !== undefined) {
    var value$4 = value$3.gems;
    var value$5 = value$3.__typename;
    currentStudent = {
      __typename: value$5,
      gems: value$4
    };
  } else {
    currentStudent = null;
  }
  return {
          currentStudent: currentStudent,
          bog_user_backgrounds: bog_user_backgrounds,
          storyverse_user_points_view: storyverse_user_points_view
        };
}

function serializeVariables(inp) {
  return {
          userId: inp.userId,
          userUuid: inp.userUuid
        };
}

function makeVariables(userId, userUuid, param) {
  return {
          userId: userId,
          userUuid: userUuid
        };
}

var StoryverseNavigationQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query$1,
      Raw: Raw$1,
      parse: parse$1,
      serialize: serialize$1,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var StoryverseNavigationQuery = {
  StoryverseNavigationQuery_inner: StoryverseNavigationQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useFetch: useFetch
};

function convertSpBar(res) {
  return Belt_Option.mapWithDefault(Belt_Option.flatMap(res, (function (p) {
                    var points = Belt_Option.getWithDefault(p.points, 0);
                    return [
                            points,
                            Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.flatMap(p.currentLevel, (function (__x) {
                                            return Belt_Array.get(__x, 0);
                                          })), (function (p) {
                                        return [
                                                p.level,
                                                p.points
                                              ];
                                      })), [
                                  1,
                                  0
                                ]),
                            Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.flatMap(p.nextLevel, (function (__x) {
                                            return Belt_Array.get(__x, 0);
                                          })), (function (p) {
                                        return [
                                                p.level,
                                                p.points
                                              ];
                                      })), [
                                  2,
                                  points
                                ])
                          ];
                  })), {
              fromValue: 0,
              toValue: 200,
              currentValue: 0,
              fromLevel: 1,
              toLevel: 2,
              hasReachedMaxLevel: false
            }, (function (param) {
                var match = param[2];
                var toLevel = match[0];
                var match$1 = param[1];
                var fromLevel = match$1[0];
                return {
                        fromValue: match$1[1],
                        toValue: match[1],
                        currentValue: param[0],
                        fromLevel: fromLevel,
                        toLevel: toLevel,
                        hasReachedMaxLevel: fromLevel >= toLevel
                      };
              }));
}

function convertLocation(res) {
  return Belt_Array.reduce(res.bog_user_backgrounds, "Shabby Hut", (function (acc, b) {
                return b.image.title;
              }));
}

function convertGems(res) {
  return Belt_Option.mapWithDefault(res.currentStudent, "0", (function (u) {
                return String(u.gems);
              }));
}

function convert(res) {
  return {
          location: convertLocation(res),
          spBar: convertSpBar(Belt_Array.get(res.storyverse_user_points_view, 0)),
          gems: convertGems(res)
        };
}

function handleResponse(res) {
  return {
          TAG: "NavLoaded",
          _0: convert(res)
        };
}

function onResult(query) {
  return Belt_Result.map(query, handleResponse);
}

var Q = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw$1,
      use: use,
      useFetch: useFetch
    });

function onLoading(param) {
  return "LoadingNav";
}

function defaultState(param) {
  return "LoadingNav";
}

function use$1(skip) {
  var u = UserContext$LiteracyplanetClientFlags.use();
  var userId = u.userId;
  return Curry._5(Q.useSkippableWithErrorModal, defaultState, onLoading, onResult, skip, {
              userId: userId,
              userUuid: HasuraTypes$LiteracyplanetClientFlags.encode(userId)
            });
}

var decode = HasuraTypes$LiteracyplanetClientFlags.decode;

var error = "Error fetching StoryverseNavigationQuery";

export {
  StoryverseUserPointsFragment ,
  StoryverseNavigationQuery ,
  decode ,
  convertSpBar ,
  convertLocation ,
  convertGems ,
  convert ,
  handleResponse ,
  onResult ,
  Q ,
  onLoading ,
  defaultState ,
  error ,
  use$1 as use,
}
/* query Not a pure module */
